export default "__VITE_ASSET__BBC_0z4y__"